<template>
  <div>
    <br />
    <b-card no-body>
      <b-tabs card>
        <b-tab title="High Risk Report" active>
          <b-card>
            <b-row
              ><b-col><h2>High Risk Report</h2></b-col></b-row
            >
            <b-row
              ><b-col
                ><p class="explain">
                  This report will show Extremely High Risk devices grouped by
                  locations or for selected company.
                </p></b-col
              ></b-row
            >
            <b-row
              ><b-col cols="3">Select grouping type:</b-col>
              <b-col cols="4"
                ><b-select
                  v-model="GroupingSelected"
                  :options="this.GroupOptions"
                  value-field="id"
                  text-field="text"
                ></b-select
              ></b-col>
              <b-col cols="1"
                ><b-button
                  size="sm"
                  variant="outline-info"
                  v-on:click="submitHRGroup()"
                  >Submit</b-button
                ></b-col
              >
              <b-col cols="1"
                ><b-button
                  size="sm"
                  variant="outline-info"
                  v-on:click="resetHRGroup()"
                  >Reset</b-button
                ></b-col
              >
            </b-row>
            <hr />
            <b-row class="text-center"
              ><b-col cols="1"></b-col><b-col><h4>Results</h4></b-col>
              <b-row
                ><b-col cols="1"
                  ><img
                    id="menuGraphic"
                    align="right"
                    src="../assets/PDFIconSmall.png"
                    v-on:click="createPDF('HighRisk')"/></b-col></b-row
            ></b-row>
            <br />
            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
            ></b-pagination>
            <b-table
              id="ResultsTable"
              :items="this.reportvalues"
              :per-page="perPage"
              :current-page="currentPage"
              empty-text="There are no results for current filter"
              no-border-collapse
              hover
              show-empty
              responsive
              small
              class="text-center"
            >
              <template #head(Filter)>
                <span v-if="GroupingSelected == 'ClientCompanies'"
                  >Company</span
                >
                <span v-if="GroupingSelected == 'Locations'">Location</span>
              </template>
              <template #head(Count)>
                <span v-if="GroupingSelected != null">Count</span>
              </template>
            </b-table>
          </b-card>
        </b-tab>
        <b-tab title="Offline Report" lazy>
          <b-card>
            <b-row
              ><b-col><h2>Offline Report</h2></b-col></b-row
            >
            <b-row
              ><b-col
                ><p class="explain">
                  This report will show devices that are offline grouped by
                  locations or for selected company.
                </p></b-col
              ></b-row
            >
            <b-row
              ><b-col cols="3">Select grouping type:</b-col>
              <b-col cols="4"
                ><b-select
                  v-model="GroupingSelected"
                  :options="this.GroupOptions"
                  value-field="id"
                  text-field="text"
                ></b-select
              ></b-col>
              <b-col cols="1"
                ><b-button
                  size="sm"
                  variant="outline-info"
                  v-on:click="submitOffGroup()"
                  >Submit</b-button
                ></b-col
              >
              <b-col cols="1"
                ><b-button
                  size="sm"
                  variant="outline-info"
                  v-on:click="resetOffGroup()"
                  >Reset</b-button
                ></b-col
              >
            </b-row>
            <hr />
            <b-row class="text-center"
              ><b-col cols="1"></b-col><b-col><h4>Results</h4></b-col>
              <b-row
                ><b-col cols="1"
                  ><img
                    id="menuGraphic"
                    align="right"
                    src="../assets/PDFIconSmall.png"
                    v-on:click="createPDF('Offline')"/></b-col></b-row
            ></b-row>
            <br />
            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
            ></b-pagination>
            <b-table
              id="ResultsTable"
              :items="this.reportvalues2"
              :per-page="perPage"
              :current-page="currentPage"
              empty-text="There are no results for current filter"
              no-border-collapse
              hover
              show-empty
              responsive
              small
              class="text-center"
            >
              <template #head(Filter)>
                <span v-if="GroupingSelected == 'ClientCompanies'"
                  >Company</span
                >
                <span v-if="GroupingSelected == 'Locations'">Location</span>
              </template>
              <template #head(Count)>
                <span v-if="GroupingSelected != null">Count</span>
              </template>
            </b-table>
          </b-card>
        </b-tab>
      </b-tabs>
    </b-card>

    <VueHtml2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="false"
      :paginate-elements-by-height="2400"
      :pdf-quality="2"
      :manual-pagination="true"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      ref="html2pdf"
    >
      <section slot="pdf-content">
        <b-row class="text-right"
          ><b-col cols="11">
            <img
              src="../assets/AGBlackGCrop.png"
              style="height:100px; margin: none; padding: none;"/></b-col
        ></b-row>
        <b-row v-if="this.PDFExport == 'Offline'"
          ><b-col cols="8"><h3>Clarence Offline Devices</h3> </b-col></b-row
        >
        <b-row v-if="this.PDFExport == 'High Risk'"
          ><b-col cols="8"
            ><h3>Clarence Extremely High Risk Devices</h3>
          </b-col></b-row
        >
        <b-row
          ><b-col
            ><h4>{{ this.ParentCompany }}</h4>
          </b-col></b-row
        >
        <b-row
          ><b-col
            ><h4>Generated: {{ this.now }}</h4>
          </b-col></b-row
        >
        {{ this.PDFExport }}
        <hr />
        <b-table
          v-if="this.PDFExport == 'Offline'"
          id="ResultsTable"
          :items="this.reportvalues2"
          :per-page="perPage"
          :current-page="currentPage"
          empty-text="There are no results for current filter"
          no-border-collapse
          hover
          show-empty
          responsive
          small
          class="text-center"
        >
          <template #head(Filter)>
            <span v-if="GroupingSelected == 'ClientCompanies'">Company</span>
            <span v-if="GroupingSelected == 'Locations'">Location</span>
          </template>
          <template #head(Count)>
            <span v-if="GroupingSelected != null">Count</span>
          </template>
        </b-table>
        <b-table
          v-if="this.PDFExport == 'HighRisk'"
          id="ResultsTable"
          :items="this.reportvalues"
          :per-page="perPage"
          :current-page="currentPage"
          empty-text="There are no results for current filter"
          no-border-collapse
          hover
          show-empty
          responsive
          small
          class="text-center"
        >
          <template #head(Filter)>
            <span v-if="GroupingSelected == 'ClientCompanies'">Company</span>
            <span v-if="GroupingSelected == 'Locations'">Location</span>
          </template>
          <template #head(Count)>
            <span v-if="GroupingSelected != null">Count</span>
          </template>
        </b-table>
        <hr />
        <b-row class="text-center"
          ><b-col>Generated from Seraph Protect</b-col></b-row
        >
      </section>
    </VueHtml2pdf>
  </div>
</template>

<script>
import axios from "axios";
import VueHtml2pdf from "vue-html2pdf";

export default {
  computed: {
    rows() {
      return this.reportvalues.length;
    },
    htmlToPdfOptions() {
      return {
        margin: 2,
        filename: this.PDFName,
        image: {
          type: "jpeg",
          quality: 0.98,
        },
        pagebreak: { mode: "avoid-all", after: ".avoidThisRow" },
      };
    },
  },
  components: {
    VueHtml2pdf,
  },

  data() {
    return {
      GroupingSelected: null,
      GroupOptions: [
        { id: null, text: "Please Select an Option" },
        { id: "ClientCompanies", text: "Client Company" },
        { id: "Locations", text: "Locations" },
      ],
      perPage: 15,
      currentPage: 1,
      selectedlocation: localStorage.getItem("CurrentLocation"),
      reportvalues: [],
      fields: [
        { key: "Filter", label: "Filter" },
        { key: "Count", label: "Count" },
      ],
      now: null,
      ParentCompany: localStorage.getItem("ParentCompany"),
      reportvalues2: [],
      fields2: [
        { key: "Filter", label: "Filter" },
        { key: "Count", label: "Count" },
      ],
      PDFExport: "",
      PDFName: "ThisGuy",
    };
  },

  beforeMount() {},

  mounted() {},

  methods: {
    createPDF(type) {
      if (this.GroupingSelected == null) {
        alert("Please generate report before trying to export");
      } else {
        this.PDFExport = type;
        let nowstamp = new Date();
        this.now = nowstamp.toLocaleString();
        this.$refs.html2pdf.generatePdf();
      }
      this.PDFExport = "";
    },
    resetHRGroup() {
      this.GroupingSelected = null;
      this.PDFExport = "";
      this.reportvalues = [];
    },
    submitHRGroup() {
      if (this.GroupingSelected == null) {
        alert("Please select a grouping type");
      } else {
        let GroupType = this.GroupingSelected;

        let LookUpUrl =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/su-reports";
        let LookUpHeaders = this.$apikeyPost;
        this.LookUpRequest = {
          Report: "extremely_high_risk_devices",
          RequestType: GroupType,
          RequestVariable: this.ParentCompany,
        };
        axios
          .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
          .then((response) => {
            let responsearray = response.data.Values;
            this.reportvalues = [];

            for (let i = 0; i < responsearray.length; i++) {
              this.reportvalues.push({
                Filter: responsearray[i][0],
                Count: responsearray[i][1],
              });
            }
          });
      }
    },
    resetOffGroup() {
      this.GroupingSelected = null;
      this.PDFExport = "";
      this.reportvalues2 = [];
    },
    submitOffGroup() {
      if (this.GroupingSelected == null) {
        alert("Please select a grouping type");
      } else {
        let GroupType = this.GroupingSelected;

        let LookUpUrl =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/su-reports";
        let LookUpHeaders = this.$apikeyPost;
        this.LookUpRequest = {
          Report: "device_communication_errors",
          RequestType: GroupType,
          RequestVariable: this.ParentCompany,
        };
        axios
          .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
          .then((response) => {
            let responsearray = response.data.Values;
            this.reportvalues2 = [];

            for (let i = 0; i < responsearray.length; i++) {
              this.reportvalues2.push({
                Filter: responsearray[i][0],
                Count: responsearray[i][1],
              });
            }
          });
      }
    },
  },
};
</script>

<style>
.pagination {
  font-size: small;
}
</style>
